<template>
    <ui-modal id="add-comments" :title="title" title-text="Deixe-nos saber em que podemos te ajudar" size="md">
        <template #avatar> 
            <img :src="user.avatar" alt="">
        </template>
        <form v-on:submit.prevent="save">
            <div class="msg" v-if="message">{{message}}</div>
            <div class="textarea-box">
                <textarea id="input-text" placeholder="Escreva seu comentário" v-textarea-resize v-model="form.text"></textarea>
            </div>
            <div class="control">
                <button type="submit" :class="indicator">Registrar Comentário </button>
            </div>
        </form>
    </ui-modal>
</template>

<script>
    import { uiModal } from '@/components'
    import { conversations, storage } from '@/services'
    import { textareaResize } from '@/directives'
    
    export default {
        name: 'login',
        components: { uiModal },
        directives: { textareaResize },
        computed: {
            indicator(){
                return this.load ? 'load' : ''
            },
        },
        data() {
            return {
                statusModal: false,
                user: null,
                message: '',
                load: false,
                title: 'Adicionar Comentário',
                form: {
                    text: '',
                    module: this.module,
                    row_id: this.row
                }
            }
        },
        props: {
            row: {
                type: String,
                required: true,
            },
            module: {
                type: String,
                required: true,
            },
            comment:{
                required: false,
            }
        },
        watch:{
            row: function(newValue){
                return newValue
            },
            comment: function(comment){
                if(comment){
                    this.form.id = comment.id
                    this.form.text = comment.text
                }else{
                    this.form.text = ''
                }
                this.setTitle()
                return comment
            }
        },
        methods: {
            save(){
                this.load = true;
                if(!this.comment){
                    conversations.add(this.form).then( response => {
                        this.$root.$emit('reload-comments', response.data.row);
                        this.load = false;
                    }, error => {
                        this.message = error.response.data.message
                        this.load = false;
                    })
                }else{
                    conversations.update(this.form).then( response => {
                        response.data.row.index = this.comment.index
                        this.$root.$emit('reload-comment', response.data.row);
                        this.load = false;
                    }, error => {
                        this.message = error.response.data.message
                        this.load = false;
                    })
                }
            },
            getCurrentUser(){
                this.user = storage.getUser()
            },
            setTitle(){
                this.title = this.comment ? 'Editar Comentário' : 'Adicionar Comentário'
            }
        },
        created(){
            this.getCurrentUser()
		}
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
